module.exports = __webpack_public_path__ + "media/packs/static/fonts/circular-std/book-b9b1abe339ba6639afffbad2d818f23d.woff";